import React from 'react'

const Corousel = (props) => {
  return (
        <img src="../assets/spon1.svg" alt='sponsor' className='md:w-[75%] md:h-[75%] pointer-events-none w-[75%] h-[75%] ml-5'></img>
  )
}

export default Corousel